<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="khid"  class="lable-width" label="NFC卡号" :rules="{required: true, message: '请选择仓库', trigger: 'blur'}">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.name" :disabled="isHide"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="name" class="lable-width" label="编号" :rules="{required: true, message: '请输入库区名', trigger: 'blur'}">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.name" :disabled="isHide"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="mj" class="lable-width" label="用户" >
                <div style="margin-left: 0px;position: relative">
                    <el-input class="input-width" label="123" placeholder="请输入面积"  clearable v-model="editData.mj" :disabled="isHide"></el-input>
                </div>
            </el-form-item>

            <el-form-item prop="rl" class="lable-width" label="余额">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  disabled clearable v-model="editData.rl"></el-input>
                </div>
            </el-form-item>
            <el-form-item  label="状态">
                <div style="margin-left: 34px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item prop="note" class="lable-width" label="录入人">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.note" :disabled="isHide"></el-input>
                </div>
            </el-form-item>

            <el-form-item prop="createime" class="lable-width" label="录入时间">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.createTime"></el-input>
                </div>
            </el-form-item>

<!--            <el-form-item prop="lruName" class="lable-width" label="录入人姓名">-->
<!--                <div style="margin-left: 0px;position: relative">-->
<!--                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.lruName"></el-input>-->
<!--                </div>-->
<!--            </el-form-item>-->


            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)" :disabled="isDisable">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'addCard',
        props:{

        },
        data(){
            return{

                // rules: {
                //     mj: [
                //         {required: true, message: '请输入面积', trigger: 'blur'},
                //         // {pattern: /^-?\d+(\.\d+)?$/, message: "请输入合法面积", trigger: "blur" },
                //         {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入大于0的数字", trigger: "blur" },
                //         {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                //     ]
                //
                // }

            }
        },

        mounted(){

        },
        methods:{

        }

    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>